var map = {
	"./Srinath.gif": 120,
	"./Srinath.svg": 121,
	"./abcd.png": 122,
	"./address_image.svg": 123,
	"./aicte.png": 124,
	"./animated_logo.svg": 125,
	"./aviatrix.png": 126,
	"./blogs_image.svg": 127,
	"./cloud_infrastructure.svg": 128,
	"./contactMail.png": 129,
	"./coursera.png": 130,
	"./data_science.svg": 131,
	"./developerActivity.svg": 132,
	"./education.svg": 133,
	"./experience.svg": 134,
	"./feelingProud.svg": 135,
	"./freecopy_logo.png": 136,
	"./fullstack.svg": 137,
	"./gcp_logo.png": 138,
	"./github_logo.png": 139,
	"./googleAssistant.jpg": 140,
	"./googleAssistant.svg": 141,
	"./google_logo.png": 142,
	"./hyper.png": 143,
	"./ibm_logo.png": 144,
	"./intel_logo.jpg": 145,
	"./jsFramework.svg": 146,
	"./krishnaveni.png": 147,
	"./linkedin.png": 148,
	"./manOnTable.svg": 149,
	"./microsoft_logo.png": 150,
	"./mypic.png": 151,
	"./narayana.png": 152,
	"./nptel_logo.png": 153,
	"./portfolio.gif": 154,
	"./programmer.svg": 155,
	"./projects_image.svg": 156,
	"./pvpsit_logo.png": 157,
	"./s.png": 158,
	"./sp.gif": 159,
	"./spoken.png": 160,
	"./spoken_tut.png": 161,
	"./talksCardBack.svg": 162,
	"./talksCardBackAlt.svg": 163,
	"./udemy.png": 164,
	"./ui_ux_design.svg": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;